import { HttpClientXHR } from "./http.client";

export class GenericHttpClient<T> extends HttpClientXHR {
  path: string;

  constructor(path: string) {
    super();
    this.path = path;
  }

  async findOne(args: { id: string; query?: any }): Promise<T> {
    const response = await this.get<T>(`${this.path}/${args.id}`, { params: args.query });
    return response.data;
  }

  async find(args: { query?: any }): Promise<T[]> {
    const response = await this.get<T[]>(this.path, { params: args.query });
    return response.data;
  }

  async findArchived(): Promise<T[]> {
    const response = await this.get<T[]>(`${this.path}/archived`);
    return response.data;
  }

  async search(args: { searchTerm: string }): Promise<T[]> {
    const response = await this.get<T[]>(`${this.path}/search`, {
      params: { searchTerm: args.searchTerm },
    });
    return response.data;
  }

  async create(args: { data: T; query?: any }): Promise<T> {
    const response = await this.post<T>(this.path, args.data, { params: args.query });
    return response.data;
  }

  async updateOne(args: { id: string; data: T; query?: any }): Promise<T> {
    const response = await this.put<T>(`${this.path}/${args.id}`, args.data, {
      params: args.query,
    });
    return response.data;
  }

  async deleteOne(args: { id: string }): Promise<T> {
    const response = await this.delete<T>(`${this.path}/${args.id}`);
    return response.data;
  }

  async archiveOne(args: { id: string }): Promise<T> {
    const response = await this.put<T>(`${this.path}/${args.id}/archive`);
    return response.data;
  }

  async unarchiveOne(args: { id: string }): Promise<T> {
    const response = await this.put<T>(`${this.path}/${args.id}/unarchive`);
    return response.data;
  }
}
